import { withStyles } from '@material-ui/core/styles';
import { Menu as BaseMenu, MenuProps } from '@material-ui/core';
import React from 'react';


export const Menu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props: MenuProps) => (
  <BaseMenu
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    elevation={0}
    getContentAnchorEl={null}
    keepMounted
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
));